import $ from 'jquery'

$('.floating-schedule__title').on('click', function () {
  $(this).parent().find('.floating-schedule__content').slideToggle(250)
})
